<template>
    <form
        class="o-loginRegister o-loginRegister--login"
        @submit.prevent="handleSubmit"
    >
        <div>
            <p class="a-title o-loginRegister__title">Logowanie</p>
            <a-button
                class="o-loginRegister__loginRegisterButton"
                type="fullwidth-light"
                @click="$router.push({ name: 'register' })"
            >
                Nie posiadasz konta?<br />
                <br />
                Zarejestruj się i wypróbuj Agriibazę!
                <template v-if="trialDays && trialDays > 0">
                    Dołącz do Nas i otrzymaj
                    dostęp testowy na {{ trialDays }} dni.
                </template>
            </a-button>
        </div>
        <div>
            <p class="a-label o-loginRegister__label">E-mail</p>
            <div class="a-control o-loginRegister__inputLogin">
                <input
                    class="a-control__input o-loginRegister__input"
                    v-model="email"
                    type="text"
                    placeholder="Wpisz email..."
                    autocomplete="username"
                />
            </div>
            <br />
            <p class="a-label o-loginRegister__label">Hasło</p>
            <div class="a-control o-loginRegister__inputPassword">
                <input
                    class="a-control__input o-loginRegister__input"
                    v-model="password"
                    type="password"
                    placeholder="Wpisz hasło..."
                    autocomplete="current-password"
                />
            </div>
            <p class="o-loginRegister__text">
                Nie pamiętasz hasła?
                <a
                    href="#"
                    class="o-loginRegister__link"
                    @click.prevent.stop="
                        $router.push({ name: 'reset-password' })
                    "
                    >Kliknij.</a
                >
            </p>
        </div>

        <div>
            <a-button
                class="o-loginRegister__button"
                type="fullwidth-light"
                icon="Login"
                :submit="true"
                :is-processing="authStatus === 'pending'"
            >
                Zaloguj
            </a-button>
            <p class="o-loginRegister__version">
                v{{ version }}
                <span v-if="environment !== 'production'">{{
                    environment
                }}</span>
            </p>
        </div>
    </form>
</template>

<script>
export default {
    metaInfo: {
        title: 'Logowanie'
    },
    data() {
        return {
            email:
                process.env.NODE_ENV !== 'production' &&
                process.env.VUE_APP_EMAIL
                    ? process.env.VUE_APP_EMAIL
                    : '',
            password:
                process.env.NODE_ENV !== 'production' &&
                process.env.VUE_APP_PASS
                    ? process.env.VUE_APP_PASS
                    : ''
        }
    },
    computed: {
        version() {
            return process.env.PACKAGE_VERSION
        },
        environment() {
            return process.env.VUE_APP_MODE
        },
        authStatus() {
            return this.$store.getters.authStatus
        },
        trialDays() {
            return this.$store.getters['subscriptions/trialDays']
        }
    },
    methods: {
        handleSubmit() {
            this.$store
                .dispatch('authLogin', {
                    email: this.email,
                    password: this.password
                })
                .then(() => {
                    this.$router.push({ name: 'dashboard' })
                })
                .catch(error => {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: 'Podano zły email lub hasło'
                    })
                    // if not wrong authorization data then errorlog
                    if (error.response.status !== 401) {
                        console.error(error)
                    }
                })
        }
    },
    mounted() {
        this.$store
            .dispatch('authCheckTokenValidity')
            .then(() => {
                this.$router.push({ name: 'dashboard' })
            })
            .catch(() => {})
    },
    created() {
        this.$store.dispatch('subscriptions/fetchTrialDays')
    }
}
</script>
